/*
Запоминает необходимую категорию. Используется при переходе со страницы категории на страницу статьи
 */
import { useContext } from 'react';

import { CategoryContext } from '../store/Category/CategoryContext';

export function useCategory() {
  return useContext(CategoryContext);
}
